import type {InitializeResult, ReconnectResult} from '@microsoft/agent-host-protocol'

const COPILOT_PASSIVE_META_KEY = 'copilot.passive'

export type PassiveHandshakeResult = (InitializeResult | ReconnectResult) & {
  _meta?: Record<string, unknown>
}

export function isPassiveHandshakeResult(result: PassiveHandshakeResult): boolean {
  return result._meta?.[COPILOT_PASSIVE_META_KEY] === true
}
